import React from "react";

import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { QRCodeCanvas } from "qrcode.react";
import { ConvertDate } from "../../../Base/helper/baseFunctions";

const VisitorInviteQR = ({
  invitedBy,
  name,
  purpose,
  phone,
  locationTitle,
  validFrom,
  validTo,
  qrCodeUrl,
  logoUrl = "https://meepldevstorage.nyc3.digitaloceanspaces.com/fulllogo.PNG",
}) => {
  const styles = {
    wrapper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "10px",
    },

    container: {
      width: "430px",
      background: "#fff",
      borderRadius: "22px",
      padding: "24px",
      fontFamily: "'Inter', sans-serif",
      boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
      border: "1px solid #e5e5e5",
      color: "#111",
    },

    topRow: {
      display: "flex",
      justifyContent: "end",
      alignItems: "center",
      marginBottom: "14px",
    },

    logo: {
      height: "42px",
      objectFit: "contain",
    },

    inviteTag: {
      background: "#f4b400",
      color: "#000",
      padding: "10px 18px",
      borderRadius: "12px",
      fontWeight: 700,
      fontSize: "12px",
      letterSpacing: "0.5px",
    },

    subTitle: {
      color: "#555",
      fontSize: "14px",
      marginBottom: "4px",
    },

    invitedBy: {
      color: "#d89b00",
      fontSize: "30px",
      fontWeight: "700",
      lineHeight: 1.2,
      marginBottom: "10px",
    },

    divider: {
      height: "2px",
      width: "100%",
      background: "#efb21d",
      marginBottom: "18px",
      position: "relative",
      borderRadius: "10px",
    },

    dot: {
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      background: "#efb21d",
      position: "absolute",
      right: 0,
      top: "-4px",
    },

    infoBlock: {
      display: "flex",
      gap: "14px",
      alignItems: "flex-start",
      marginBottom: "18px",
    },

    iconWrap: {
      width: "38px",
      height: "38px",
      borderRadius: "50%",
      background: "#d89b00",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "#fff",
      flexShrink: 0,
    },

    label: {
      fontSize: "14px",
      color: "#666",
      marginBottom: "4px",
    },

    value: {
      fontSize: "18px",
      fontWeight: 700,
      color: "#111",
      lineHeight: 1.2,
    },

    bottomCard: {
      marginTop: "20px",
      background: "#faf6ef",
      borderRadius: "16px",
      padding: "14px",
      display: "flex",
      flexDirection: "column",
      gap: "14px",
    },

    section: {
      display: "flex",
      alignItems: "flex-start",
      gap: "12px",
      width: "100%",
    },

    verticalDivider: {
      height: "1px",
      width: "100%",
      background: "#e4c77d",
    },

    smallText: {
      fontSize: "12px",
      color: "#444",
      lineHeight: 1.5,
      wordBreak: "break-word",
    },

    locationTitle: {
      fontWeight: 700,
      fontSize: "14px",
      marginBottom: "4px",
      color: "#222",
    },
    sectionContent: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
    },
    qrText: {
      textAlign: "center",
      fontSize: "15px",
      color: "#555",
      marginTop: "18px",
      marginBottom: "4px",
    },

    qrWrapper: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "4px",
    },

    qrCode: {
      width: "220px",
      height: "220px",
      objectFit: "contain",
    },

    footer: {
      textAlign: "center",
      fontWeight: 700,
      fontSize: "13px",
      color: "#555",
    },
  };

  const InfoItem = ({ icon, label, value }) => (
    <div style={styles.infoBlock}>
      <div style={styles.iconWrap}>{icon}</div>

      <div>
        <div style={styles.label}>{label}</div>
        <div style={styles.value}>{value}</div>
      </div>
    </div>
  );

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        {/* Header */}
        <div style={styles.topRow}>
          {/* <img src={logoUrl} alt="Meepl Logo" style={styles.logo} /> */}

          <div style={styles.inviteTag}>VISITOR INVITE</div>
        </div>

        {/* Invite Text */}
        <div style={styles.subTitle}>You are invited by</div>

        <div style={styles.invitedBy}>{invitedBy}</div>

        <div style={styles.divider}>
          <div style={styles.dot}></div>
        </div>

        {/* Visitor Info */}
        <InfoItem
          icon={<PersonOutlineIcon sx={{ fontSize: 22 }} />}
          label="Guest Name"
          value={name}
        />

        <InfoItem
          icon={<ChatBubbleOutlineIcon sx={{ fontSize: 22 }} />}
          label="Purpose"
          value={purpose}
        />

        <InfoItem
          icon={<PhoneOutlinedIcon sx={{ fontSize: 22 }} />}
          label="Mobile"
          value={phone}
        />

        {/* Bottom Card */}
        <div style={styles.bottomCard}>
          <div style={styles.section}>
            <div style={styles.iconWrap}>
              <CalendarMonthOutlinedIcon sx={{ fontSize: 22 }} />
            </div>

            <div style={styles.sectionContent}>
              <div style={styles.locationTitle}>Visit Date</div>

              <div style={styles.smallText}>
                {ConvertDate(validFrom)}
              </div>
            </div>
          </div>

          { locationTitle &&
            <>
              <div style={styles.verticalDivider}></div>

              <div style={{...styles.section, alignItems: "center"}}>
                <div style={styles.iconWrap}>
                  <LocationOnOutlinedIcon sx={{ fontSize: 22 }} />
                </div>

                <div style={styles.sectionContent}>
                  <div style={styles.locationTitle}>{locationTitle}</div>
                </div>
              </div>
            </>
          }
        </div>

        {/* QR */}
        <div style={styles.qrText}>Scan this QR Code at entry gate</div>

        <div style={styles.qrWrapper}>
          <QRCodeCanvas
            value={qrCodeUrl || "https://meepl.day"}
            size={250}
            bgColor="#ffffff"
            fgColor="#000000"
            level="H"
            includeMargin={true}
          />
        </div>

        {/* Footer */}
        <div style={styles.footer}>powered by Meepl</div>
      </div>
    </div>
  );
};

export default VisitorInviteQR;
